import { useApi } from './useApi';

export function useBalanceHistories() {
  const { fetchData, postData, putData } = useApi();
  const fetchBalanceHistoriesApi = async (params = {}) => {
    try {
      const result = await fetchData('/api/balance_histories', { params });
      return { success: true, data: result };
    } catch (err) {
      return { success: false, error: err.message || 'Lỗi kết nối' };
    }
  };

  const deleteBalanceHistoriesApi = async (id) => {
    try {
      return { success: true };
    } catch (err) {
      return { success: false, error: err.message };
    }
  };

  const getBalanceHistoriesDetailApi = async (id) => {
      try {
          const result = await fetchData(`/api/balance_histories/${id}?include=items,customer&searchJoin=AND`);
          return { success: true, data: result };
      } catch (err) {
          return { success: false, error: err.message || 'Lỗi kết nối' };
      }
  };

  const createBalanceHistoriesApi = async (credentials) => {
    try {
      const result = await postData('/api/balance_histories', credentials);
      return { success: true, data: result };
    } catch (err) {
      return { success: false, error: err.message };
    }
  };

  const updateBalanceHistoriesApi = async (id, credentials) => {
      try {
          const result = await putData(`/api/balance_histories/${id}`, credentials);
          return { success: true, data: result };
      } catch (err) {
          return { success: false, error: err.message || 'Lỗi kết nối' };
      }
  };

  return { fetchBalanceHistoriesApi, deleteBalanceHistoriesApi, createBalanceHistoriesApi, getBalanceHistoriesDetailApi, updateBalanceHistoriesApi };
}
